import styled from 'styled-components'

const DataLineItem = styled.div`
  font-size: 14px;
`

export const ExtentsText = styled.span`
  color: ${({ theme }) => theme.textSecondary};
  font-size: 12px;
  margin-right: 8px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `};
`

export const RangeLineItem = styled(DataLineItem)<{ align?: 'center' | 'flex-start' }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  // align-items: ${({ align }) => align ?? 'center'};

  width: 100%;
`

export const RangeText = styled.div`
  /* background-color: ${({ theme }) => theme.deprecated_bg2}; */
  padding: 0.25rem 0;
  font-size: 12px;

  border-radius: 8px;

  color: ${({ theme }) => theme.textPrimary};
  display: flex;
  flex-direction: row;
  align-items: center;
  & > *:not(:last-child) {
    margin-right: 4px;
  }
`
